import React from 'react';
import PropTypes from 'prop-types';

import PriceDisplay from '@stubhub/react-price-display';

import './index.scss';

/**
 * Renders the core component for displaying an advisory price.
 *
 * @param {boolean} isDataLoading - Indicates whether the data is currently loading.
 * @param {string} exchangeCurrency - The currency of the exchange price.
 * @param {number} exchangePrice - The exchange price to be displayed.
 * @param {number} decimalPlaces - The number of decimal places to display.
 * @param {string} className - The CSS class name for the component.
 * @returns {JSX.Element} The rendered AdvisoryPriceDisplayCore component.
 */
const AdvisoryPriceDisplayCore = ({isDataLoading, exchangeCurrency, exchangePrice, decimalPlaces, className}) => (
  <div className="AdvisoryPriceDisplay__content">
    <PriceDisplay
      className={className}
      price={exchangePrice}
      currency={exchangeCurrency}
      decimalPlaces={decimalPlaces}
      isLoading={isDataLoading}
    />
  </div>
);

AdvisoryPriceDisplayCore.propTypes = {
  /** Is set to true in the controller if the exchange data is being loaded */
  isDataLoading: PropTypes.bool,

  /** The currency to be shown */
  exchangeCurrency: PropTypes.string,

  /** The price to be shown */
  exchangePrice: PropTypes.number,

  /** How many decimals to be shown in price */
  decimalPlaces: PropTypes.number,

  /** The classname to pass to PriceDisplay */
  className: PropTypes.string,
};

export default AdvisoryPriceDisplayCore;
